import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import InvitationService from "@/integrations/service/invitation.service";

export const useInvitations = () => {
  return useQuery({
    queryKey: queryKeys.invitations,
    queryFn: InvitationService.getAll,
  });
};

export const useCreateInvitation = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: InvitationService.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.invitations });
    },
  });
};

export const useAccepterInvitation = () => {
  return useMutation({
    mutationFn: InvitationService.accepter,
  });
};

export const useAnnulerInvitation = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: InvitationService.annuler,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.invitations });
    },
  });
};

export const useSupprimerInvitation = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: InvitationService.supprimer,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.invitations });
    },
  });
};
